var IMPORT_REGEX = /^import/;
var EXPORT_REGEX = /^export/;
var EXPORT_DEFAULT_REGEX = /^export default/;
var BLOCKS_REGEX = '[a-z\\.]+(\\.){0,1}[a-z\\.]';
var EMPTY_NEWLINE = '\n\n';
module.exports.EMPTY_NEWLINE = EMPTY_NEWLINE;
module.exports.BLOCKS_REGEX = BLOCKS_REGEX;

module.exports.isImport = function (text) {
  return IMPORT_REGEX.test(text);
};

module.exports.isExport = function (text) {
  return EXPORT_REGEX.test(text);
};

module.exports.isExportDefault = function (text) {
  return EXPORT_DEFAULT_REGEX.test(text);
};